import React from 'react';
import SelectFieldMultiSelect from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelect';

const PaymentStatusFilter = <SelectFieldMultiSelect
    choices={ [
        {
            id: 'payment_status_unknown',
            name: 'filters.components.paymentStatus.choices.unknown',
        },
        {
            id: 'payment_in_progress',
            name: 'filters.components.paymentStatus.choices.inProgress',
        },
        {
            id: 'payment_failed',
            name: 'filters.components.paymentStatus.choices.failed',
        },
        {
            id: 'payment_refunded',
            name: 'filters.components.paymentStatus.choices.refunded',
        },
        {
            id: 'payment_chargedback',
            name: 'filters.components.paymentStatus.choices.chargedback',
        },
        {
            id: 'payment_success',
            name: 'filters.components.paymentStatus.choices.success',
        },
        {
            id: 'payment_deferred',
            name: 'filters.components.paymentStatus.choices.deferred',
        },
    ] }
    fullWidth={ true }
    label='filters.components.paymentStatus.label'
    placeholder='filters.components.paymentStatus.placeholder'
    source='payment_status'
/>;

export default PaymentStatusFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/PaymentStatusFilter.js